import { render, staticRenderFns } from "./BaseContainer.vue?vue&type=template&id=2cd8c200&scoped=true&"
import script from "./BaseContainer.vue?vue&type=script&lang=js&"
export * from "./BaseContainer.vue?vue&type=script&lang=js&"
import style0 from "./BaseContainer.vue?vue&type=style&index=0&id=2cd8c200&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd8c200",
  null
  
)

export default component.exports